import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "reactstrap";

import { ThemeRenderer } from "./ThemeProvider/ThemeHandler";
import ThemeFooter from "./component/ThemeFooter";
import ItemService from "../../services/OrderingServices/ItemService";
import Error500 from "../../pages/AuthenticationInner/Errors/Error500";
import OrganizationService from "../../services/OrderingServices/OrganizationService";

const OrgPage = () => {
  const [apiResponse, setApiResponse] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [orgDetail, setOrgDetail] = useState();
  const { orgcode } = useParams();
  console.log("🚀 ~ OrgPage ~ orgcode:", orgcode);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchOrgDetail = async () => {
      try {
        const response = await OrganizationService.detailByCode(orgcode);
        console.log("🚀 ~ fetchOrgDetail ~ response:", response);
        setOrgDetail(response);

        // Dynamic document title
        document.title = response?.organization?.name || "Organization Page";
      } catch (err) {
        console.error("Error fetching organization data:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    // fetchOrgDetail();
  }, [orgcode, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ItemService.itemTheme(orgcode);
        console.log("🚀 ~ fetchData ~ response:", response);
        setApiResponse(response);

        // Dynamic document title
        document.title = response?.organization?.name || "Organization Page";
      } catch (err) {
        console.error("Error fetching organization data:", err);
        setError(err);
        navigate("/");
      } finally {
        setLoading(false);
      }
    };

    // fetchData();
  }, [orgcode, navigate]);

  if (loading) return <Spinner />;
  if (error || !apiResponse || Object.keys(apiResponse).length === 0) {
    return (
      <div>
        <Error500 />
      </div>
    );
  }

  return (
    <div>
      {apiResponse && (
        <ThemeRenderer
          themeKey="Theme1"
          orgInfo={apiResponse}
          orgData={orgDetail}
        />
      )}
      <ThemeFooter />
    </div>
  );
};

export default OrgPage;
